import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardRequest,
  getBirthdayCustomersRequest,
} from "../../redux/Dashboard/dashboardSlice";
import { fetchSipPlanNamesRequest } from "../../redux/SipPlan/SipPlanSlice";
import { getAppConfig, getConfiguration } from "../../redux/Configuration/configurationSlice";
import { flex, flexBasis } from "@mui/system";
import { Column } from "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { getSettingsRequest } from "../../redux/settings/settingsSlice";
import { checkActivePlanRequest, fetchJewellerBenefitUsageRequest } from "../../redux/sagas/Subscription/SubscriptionSlice";
import { canShowPermission } from "../MainScreens/Permissions/permissionObject";
import InfoButton from "../Comman/InfoButton";
import JewellerInstalaxmiPopupDialog from "./JewellerInstalaxmiPopupDialog";
import {
  getJewellerInstalaxmiPopupRequest,
  JEWELLER_POPUP_LOGIN_FLAG,
} from "../../redux/LuckyDrawPopup/luckyDrawPopupSlice";
import { getJewellerBannerRequest } from "../../redux/LuckyDrawBanner/luckyDrawBannerSlice";
import auth from "../../configs/auth";

const benefitUsageFields = [
  { key: "customer_limit", label: "Customers" },
  { key: "admin_limit", label: "Admins" },
  { key: "store_limit", label: "Stores" },
  { key: "customer_sip_limit", label: "SIPs" },
  { key: "sip_plan_limit", label: "SIP Plans" },
  { key: "product_limit", label: "Products" },
  { key: "bulk_gift_user_limit", label: "Bulk Gift" },
];

const NewDashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useSelector((state) => state.dashboard || {});
  const benefitUsage = useSelector(
    (state) => state.subscriptionPlan?.benefitUsage || [],
  );
  const configData = useSelector((state) => state.appConfig.configData);
  const decimal = useSelector((state) => state?.appConfig?.configData?.decimalPrecision || 4);
  const [appConfigData1, setAppConfigData] = useState(null);
  useEffect(() => {
    dispatch(getDashboardRequest());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSettingsRequest());
    dispatch(getAppConfig());
    dispatch(checkActivePlanRequest());
    dispatch(getConfiguration());
    dispatch(fetchSipPlanNamesRequest());
    dispatch(getJewellerBannerRequest());

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const selectedJewellerId = sessionStorage.getItem(auth.selectedJeweller) || "";
    const userJeweller = storedUser?.jeweller;
    const userJewellerId =
      userJeweller && typeof userJeweller === "object"
        ? userJeweller._id || userJeweller.id || ""
        : userJeweller || "";
    const jewellerId =
      selectedJewellerId && String(selectedJewellerId).trim() !== ""
        ? selectedJewellerId
        : userJewellerId;
    dispatch(
      fetchJewellerBenefitUsageRequest(jewellerId ? { jewellerId } : {}),
    );
  }, []);

  useEffect(() => {
    const flag = localStorage.getItem(JEWELLER_POPUP_LOGIN_FLAG);
    console.log("[JewellerPopup] dashboard mount", {
      flag,
      path: window.location.pathname,
    });
    if (flag !== "1") {
      console.log("[JewellerPopup] skip API — flag is not 1");
      return;
    }
    console.log("[JewellerPopup] flag is 1, dispatching GET getJewellerInstalaxmiPopup");
    dispatch(getJewellerInstalaxmiPopupRequest());
  }, [dispatch]);
   useEffect(() => {
    if (configData) {
      setAppConfigData(configData);
    }
  }, [configData]);
  console.log("appConfigData", appConfigData1);

  const handleBirthdayClick = (range) => {
    //dispatch(getBirthdayCustomersRequest({ range, page: 1, limit: 10 }));
    navigate("/BirthdayCustomerList", { state: { range } });
  };

  const birthdayData = data?.birthday
    ? [
        {
          labelKey: "dashboard.birthdayNext7Days",
          count: data.birthday.sevendaybirthday || "0",
          range: 7,
        },
        {
          labelKey: "dashboard.birthdayNext15Days",
          count: data.birthday.fifteendaybirthday || "0",
          range: 15,
        },
        {
          labelKey: "dashboard.birthdayNext30Days",
          count: data.birthday.thirtydaybirthday || "0",
          range: 30,
        },
      ]
    : [];

  const metalData = Array.isArray(data?.metals)
    ? data.metals.map((item) => ({
        metal: `${item.metalName} (${item.karat}K)`,
        purity: item.purity,
        metalName: item.metalName,
        bgColor: item.metalName === "Gold" ? "#F0C040" : "#ccc",
      }))
    : [];

  const formatHoldingData = (input, labelTemplate) => {
    if (!input || typeof input !== "object") return [];
    return Object.entries(input).map(([key, val]) => {
      const metalType = key.toLowerCase().includes("gold") ? "Gold" : "Silver";
      const quantity = parseFloat(val || 0).toFixed(decimal);
      const label = labelTemplate
        .replace("{quantity}", quantity)
        .replace("{metal}", metalType);
      return {
        label,
        color: metalType === "Gold" ? "#F0C040" : "#ccc",
      };
    });
  };

  const holdingData = {
    "dashboard.jewellerCurrentBalance": formatHoldingData(
      data?.balance,
      "{quantity} Gms  [{metal}] "
    ),
    "dashboard.quantityAddedByJeweller": formatHoldingData(
      data?.addedQuantity,
      "{quantity} Gms [{metal}]"
    ),
    "dashboard.quantityRemovedByJeweller": formatHoldingData(
      data?.removedQuantity,
      "{quantity} Gms [{metal}]"
    ),
    "dashboard.totalMetalBoughtByCustomer": formatHoldingData(
      data?.boughtQuantity,
      "{quantity} Gms [{metal}] "
    ),
    "dashboard.totalMetalRedeemedByCustomer": formatHoldingData(
      data?.redeemQuantity,
      "{quantity} Gms [{metal}]"
    ),
    "dashboard.totalMetalDepositedByCustomer": formatHoldingData(
      data?.bullionDepositqty,
      "{quantity} Gms [{metal}]"
    ),
  };
  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canDashboardView = canShowPermission(permissions, "dashboard", "view");

  if (!canDashboardView) {
    // Show permission denied message centered on screen
    return (
      <>
        <JewellerInstalaxmiPopupDialog />
        <Box
          sx={{
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            px: 2,
            fontFamily: "Aeonik",
            fontWeight: 700,
            fontSize: "1.5rem",
            color: "#555",
          }}
        >
          {t("common.permissionDenied")}
        </Box>
      </>
    );
  }
  return (
    // <Box
    // // sx={{ width: "100%", height: "100vh", overflow: "hidden" }}
    // >
    //   <Box
    //   //  sx={{ height: "100%", overflowY: "auto", p: 2 }}
    //    >
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        margin: "auto",
        mt: { xs: 10, md: 10 },
        // background: "#E5E5E5",
        p: 1,
        // borderRadius: "16px",
        mb: 2,
        // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <JewellerInstalaxmiPopupDialog />
      <Box sx={{ position: "relative" }}>
      {benefitUsage.length > 0 && (
        <Box sx={{ px: 2, pb: 2, width: "100%" }}>
          {benefitUsage.map((row) => (
            <Box
              key={row.jeweller || row.jewellerName}
              sx={{
                mb: 2,
                borderRadius: "16px",
                overflow: "hidden",
                background: "#fff",
                border: "1px solid #efe6ff",
                boxShadow: "0 10px 28px rgba(112, 40, 218, 0.12)",
              }}
            >
              <Box
                sx={{
                  px: 2.5,
                  py: 1.4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "18px",
                    fontFamily: "Aeonik",
                    letterSpacing: 0.2,
                  }}
                >
                  {row.jewellerName || "Jeweller"}
                </Typography>
                {row.subscriptionStatus ? (
                  <Box
                    sx={{
                      px: 1.5,
                      py: 0.4,
                      borderRadius: "999px",
                      background: "rgba(255,255,255,0.18)",
                      border: "1px solid rgba(255,255,255,0.35)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "12px",
                      letterSpacing: 0.4,
                      textTransform: "uppercase",
                    }}
                  >
                    {row.subscriptionStatus}
                  </Box>
                ) : null}
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
                  gap: 1.25,
                  p: 1.5,
                  background: "linear-gradient(180deg, #f7f2ff 0%, #ffffff 70%)",
                }}
              >
                {benefitUsageFields.map((field) => {
                  const usage = row?.[field.key] || {};
                  const displayUsage = (value) => {
                    if (value == null || value === "") return "0";
                    const text = String(value);
                    return text.toLowerCase() === "unlimited" ? "Unlimited" : text;
                  };
                  const usageValueSx = (value) => {
                    const text = displayUsage(value);
                    const long = text.length > 4;
                    return {
                      fontSize: long ? "11px" : "20px",
                      fontWeight: 800,
                      lineHeight: long ? 1.25 : 1.1,
                      color: "#24143d",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    };
                  };
                  return (
                    <Box
                      key={field.key}
                      sx={{
                        minWidth: 0,
                        overflow: "hidden",
                        borderRadius: "12px",
                        background: "#fff",
                        border: "1px solid #eadfff",
                        boxShadow: "0 4px 12px rgba(112, 40, 218, 0.06)",
                        px: 1.25,
                        py: 1.25,
                        borderTop: "3px solid #7A3FFF",
                      }}
                    >
                      <Typography
                        noWrap
                        sx={{
                          fontSize: "12px",
                          fontWeight: 700,
                          letterSpacing: 0.4,
                          textTransform: "uppercase",
                          color: "#7A3FFF",
                        }}
                      >
                        {field.label}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 0.75, mt: 1 }}>
                        <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                          <Typography sx={usageValueSx(usage.total)}>
                            {displayUsage(usage.total)}
                          </Typography>
                          <Typography sx={{ fontSize: "11px", color: "#7a738c" }}>
                            Total
                          </Typography>
                        </Box>
                        <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                          <Typography sx={usageValueSx(usage.remaining)}>
                            {displayUsage(usage.remaining)}
                          </Typography>
                          <Typography sx={{ fontSize: "11px", color: "#7a738c" }}>
                            Remaining
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ))}
        </Box>
      )}
      {/* Birthday Cards Section */}
      <Box mt={1} sx={{ px: 2, pb: 2, width: "100%" }}>
        <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
          {birthdayData.map((item, index) => (
            <Card
              sx={{
                flexBasis: "0px",
                WebkitFlex: 1,
                flexGrow: 1,
                maxWidth: "95%", // 8px × 2 = 16px gap between items
                // width: "100%", // ensures full width
                // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                border: "2px solid #E2E2EA",
                background: "#fff",
                borderRadius: 0,
                p: 1,
                // border: "1px solid #cdcdcd", // optional
              }}
              key={index}
              onClick={() => handleBirthdayClick(item.range)}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  // borderRadius: 2,/
                  background:'#fff'
                  // borderLeft: "15px solid #E2E2EA",
                }}
              > */}
              {/* <Box sx={{ width: '5px', height: '100%', borderRadius: '4px', mr: 2
                          }} /> */}
              <CardContent sx={{ p: 1, width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography
                    // variant="h4"
                    sx={{
                      fontWeight: "bold",
                      flexShrink: 0,
                      fontSize: "16px",
                      color: "#673ab7",
                    }}
                  >
                    {item.count}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      color: "#673ab7",
                      fontWeight: "bold",
                    }}
                  >
                    {t(item.labelKey)}
                  </Typography>
                </Box>
              </CardContent>
              {/* </Box> */}
            </Card>
          ))}
        </Box>
      </Box> 
      {/* Total Application Downloads Section */}
       <Box mt={1} sx={{ px: 2, pb: 2, width: "35.9%" }}>
        <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
        
            <Card
              sx={{
                flexBasis: "0px",
                WebkitFlex: 1,
                flexGrow: 1,
                maxWidth: "95%", // 8px × 2 = 16px gap between items
                // width: "100%", // ensures full width
                // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                border: "2px solid #E2E2EA",
                background: "#fff",
                borderRadius: 0,
                p: 1,
                // border: "1px solid #cdcdcd", // optional
              }}
            
             
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  // borderRadius: 2,/
                  background:'#fff'
                  // borderLeft: "15px solid #E2E2EA",
                }}
              > */}
              {/* <Box sx={{ width: '5px', height: '100%', borderRadius: '4px', mr: 2
                          }} /> */}
              <CardContent sx={{ p: 1, width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography
                    // variant="h4"
                    sx={{
                      fontWeight: "bold",
                      flexShrink: 0,
                      fontSize: "16px",
                      color: "#673ab7",
                    }}
                  >
                    {data.customer}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      color: "#673ab7",
                      fontWeight: "bold",
                    }}
                  >
                    {t("dashboard.appsDownloads")}
                  </Typography>
                </Box>
              </CardContent>
              {/* </Box> */}
            </Card>
       
        </Box>
      </Box> 


      {/* Metal Cards Section */}
      {/* Metal Cards Section */}
      <Box sx={{ px: 2, pb: 2, width: "100%" }} mt={1}>
        <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
          {metalData.map((item, index) => {
            // Dynamic column size: if only 2 metals, split 50%-50%, else default
            const mdSize = metalData.length === 2 ? 6 : 4;
            const smSize = metalData.length === 2 ? 6 : 6;

            return (
              <Box
                sx={{
                  flexBasis: "0px",
                  WebkitFlex: 1,
                  flexGrow: 1,
                  maxWidth: "95%", // 8px × 2 = 16px gap between items
                  // width: "100%", // ensures full width
                  // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                  p: "2px", // optional
                }}
                key={index}
              >
                <Card
                  sx={{
                    display: "flex",
                    borderRadius: 1,
                    overflow: "hidden",
                    height: 100,
                    width: "100%",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      backgroundColor: item.bgColor,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      p: 1,
                    }}
                  >
                    <Box sx={{ alignContent: "center", p: 2 }}>
                      <Typography
                        variant="h6"
                        fontWeight="600"
                        sx={{ color: "#000", fontSize: "1.5875rem" }}
                      >
                        {item.metal=="Silver (24K)"? "Silver":item.metal}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: 500,
                          fontSize: "1.075rem",
                        }}
                      >
                        {item.metal=="Silver (24K)"? "":item.purity}
                      </Typography>
                    </Box>
                    <Box>
                      <Box
                        sx={{
                          width: 80,
                          height: "100%",
                          backgroundColor: "#673ab7",
                          display: "flex",
                          borderRadius: 1,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <ArrowDownwardIcon
                          sx={{ color: "#fff", fontSize: "2.5rem" }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Quantity holding by customers */}
      <Box sx={{ px: 2, pb: 2, width: "100%" }}>
        {/* Divider */}

        <Divider
          sx={{
            mt: "1rem",
            m: 1,
            mb: "1rem",
            border: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        />
        <Typography
          fontWeight={700}
          fontSize="1.53125rem"
          fontFamily={"Aeonik"}
        >
          {t("dashboard.quantityHoldingByCustomers")}
        </Typography>
        <Divider
          sx={{
            mt: "1rem",
            m: 1,
            mb: "1rem",
            border: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        />
        <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
          {metalData.map((metal, index) => {
            const key = `${metal.metalName}${metal.purity}`;
            const holders = data?.holders?.[key] || 0;
            const holdings = data?.holdings?.[key] || 0;

            const label = `${holders} customers [ ${parseFloat(
              holdings
            ).toFixed(decimal)} Gms  ${metal.metalName} ]`;
            const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

            return (
              <Box
                key={index}
                sx={{
                  flexBasis: "0px",
                  WebkitFlex: 1,
                  flexGrow: 1,
                  maxWidth: "95%", // 8px × 2 = 16px gap between items
                  // width: "100%", // ensures full width
                  // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                  p: "2px", // optional
                }}
              >
                <Box
                  sx={{
                    backgroundColor: color,
                    p: 2,
                    borderRadius: 1,
                    color: "#000",
                    // display: "flex",
                    // alignItems: "center",
                    // width: "100%",      // instead of 350
                    minWidth: { xs: "98%", sm: "48%", md: "31%" }, // optional
                    // flexWrap: "wrap",
                  }}
                >
                  {label.split(" ").map((word, i) => (
                    <Typography
                      key={i}
                      variant="body1"
                      component="span"
                      sx={{
                        fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                        mr: 0.5,
                      }}
                    >
                      {word}
                    </Typography>
                  ))}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Customers without Holdings */}
      <Box sx={{ px: 2, pb: 2, width: "100%" }}>
        {/* Divider */}
        <Divider
          sx={{
            mt: "1rem",
            m: 1,
            mb: "1rem",
            border: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        />
        <Typography
          fontWeight={700}
          fontSize="1.53125rem"
          fontFamily={"Aeonik"}
        >
          {t("dashboard.customersWithoutHoldings")}
        </Typography>
        {/* Divider */}
        <Divider
          sx={{
            mt: "1rem",
            m: 1,
            mb: "1rem",
            border: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        />
        <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
          {" "}
          {metalData.map((metal, index) => {
            const key = `${metal.metalName}${metal.purity}`;
            const holders = data?.holders?.[key] || 0;
            const totalCustomers = Number(data?.customer || 0);
            const customersWithout = totalCustomers - holders;

            const label = `${customersWithout} customer  [${metal.metalName}] `;
            const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

            return (
              <Box
                key={index}
                sx={{
                  flexBasis: "0px",
                  WebkitFlex: 1,
                  flexGrow: 1,
                  maxWidth: "95%", // 8px × 2 = 16px gap between items
                  // width: "100%", // ensures full width
                  // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                  p: "2px", // optional
                }}
              >
                <Box
                  sx={{
                    backgroundColor: color,
                    p: 2,
                    borderRadius: 1,
                    color: "#000",
                    // display: "flex",
                    // alignItems: "center",
                    // width: "100%",      // instead of 350
                    minWidth: { xs: "98%", sm: "48%", md: "31%" }, // optional
                    // flexWrap: "wrap",
                  }}
                >
                  {label.split(" ").map((word, i) => (
                    <Typography
                      key={i}
                      variant="body1"
                      component="span"
                      sx={{
                        fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                        mr: 0.5,
                      }}
                    >
                      {word}
                    </Typography>
                  ))}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Customers Sold Quantity Section */}
<Box sx={{ px: 2, pb: 2, width: "100%" }}>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />
  <Typography fontWeight={700} fontSize="1.53125rem" fontFamily={"Aeonik"}>
    {t("dashboard.customersSoldBackMetal")}
  </Typography>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />

  <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
    {metalData.map((metal, index) => {
      const key = `${metal.metalName}${metal.purity}`;
      const soldCount = data?.soldQuantityCustomers?.[key] || 0;
      const soldBalance = data?.soldQuantity?.[key] || 0;

      const label = `${soldCount} customers [ ${parseFloat(
        soldBalance
      ).toFixed(decimal)} Gms ${metal.metalName} ]`;
      const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

      return (
        <Box key={index} sx={{ flexBasis: "0px", WebkitFlex: 1, flexGrow: 1, maxWidth: "95%", p: "2px" }}>
          <Box sx={{ backgroundColor: color, p: 2, borderRadius: 1, color: "#000" }}>
            {label.split(" ").map((word, i) => (
              <Typography
                key={i}
                variant="body1"
                component="span"
                sx={{
                  fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                  mr: 0.5,
                }}
              >
                {word}
              </Typography>
            ))}
          </Box>
        </Box>
      );
    })}
  </Box>
</Box>

{/* Customers Sold Quantity pending Section */}
<Box sx={{ px: 2, pb: 2, width: "100%" }}>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />
  <Typography fontWeight={700} fontSize="1.53125rem" fontFamily={"Aeonik"}>
    {t("dashboard.pendingSellBalanceByCustomer")}
  </Typography>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />

  <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
    {metalData.map((metal, index) => {
      const key = `${metal.metalName}${metal.purity}`;
      const soldCount = data?.pendingSellCustomers?.[key] || 0;
      const soldBalance = data?.pendingSellQuantity?.[key] || 0;

      const label = `${soldCount} customers [ ${parseFloat(
        soldBalance
      ).toFixed(decimal)} Gms ${metal.metalName} ]`;
      const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

      return (
        <Box key={index} sx={{ flexBasis: "0px", WebkitFlex: 1, flexGrow: 1, maxWidth: "95%", p: "2px" }}>
          <Box sx={{ backgroundColor: color, p: 2, borderRadius: 1, color: "#000" }}>
            {label.split(" ").map((word, i) => (
              <Typography
                key={i}
                variant="body1"
                component="span"
                sx={{
                  fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                  mr: 0.5,
                }}
              >
                {word}
              </Typography>
            ))}
          </Box>
        </Box>
      );
    })}
  </Box>
</Box>

{/* Customers for sip Section */}
<Box sx={{ px: 2, pb: 2, width: "100%" }}>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />
  <Typography fontWeight={700} fontSize="1.53125rem" fontFamily={"Aeonik"}>
    {t("dashboard.pendingSipBalanceByCustomer")}
  </Typography>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />

  <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
    {metalData.map((metal, index) => {
      const key = `${metal.metalName}${metal.purity}`;
      const soldCount = data?.pendingSipCustomers?.[key] || 0;
      const soldBalance = data?.pendingSipQuantity?.[key] || 0;

      const label = `${soldCount} customers [ ${parseFloat(
        soldBalance
      ).toFixed(decimal)} Gms ${metal.metalName} ]`;
      const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

      return (
        <Box key={index} sx={{ flexBasis: "0px", WebkitFlex: 1, flexGrow: 1, maxWidth: "95%", p: "2px" }}>
          <Box sx={{ backgroundColor: color, p: 2, borderRadius: 1, color: "#000" }}>
            {label.split(" ").map((word, i) => (
              <Typography
                key={i}
                variant="body1"
                component="span"
                sx={{
                  fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                  mr: 0.5,
                }}
              >
                {word}
              </Typography>
            ))}
          </Box>
        </Box>
      );
    })}
  </Box>
</Box>

{/* Customers for gift Section */}
<Box sx={{ px: 2, pb: 2, width: "100%" }}>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />
  <Typography fontWeight={700} fontSize="1.53125rem" fontFamily={"Aeonik"}>
    {t("dashboard.pendingGiftBalanceByCustomer")}
  </Typography>
  <Divider sx={{ mt: "1rem", m: 1, mb: "1rem", borderTop: "1px solid rgba(0, 0, 0, 0.12)" }} />

  <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
    {metalData.map((metal, index) => {
      const key = `${metal.metalName}${metal.purity}`;
      const soldCount = data?.pendingGiftReceivedCustomers?.[key] || 0;
      const soldBalance = data?.pendingGiftReceivedQty?.[key] || 0;

      const label = `${soldCount} customers [ ${parseFloat(
        soldBalance
      ).toFixed(decimal)} Gms ${metal.metalName} ]`;
      const color = metal.metalName === "Gold" ? "#F0C040" : "#ccc";

      return (
        <Box key={index} sx={{ flexBasis: "0px", WebkitFlex: 1, flexGrow: 1, maxWidth: "95%", p: "2px" }}>
          <Box sx={{ backgroundColor: color, p: 2, borderRadius: 1, color: "#000" }}>
            {label.split(" ").map((word, i) => (
              <Typography
                key={i}
                variant="body1"
                component="span"
                sx={{
                  fontWeight: /^\d+(\.\d+)?$/.test(word) ? "bold" : 500,
                  mr: 0.5,
                }}
              >
                {word}
              </Typography>
            ))}
          </Box>
        </Box>
      );
    })}
  </Box>
</Box>

      {/* Remaining Holding Data Sections */}
      {Object.entries(holdingData).map(
        ([sectionTitle, dataArr], sectionIndex) => (
          <Box key={sectionIndex} sx={{ px: 2, width: "100%" }}>
            <Divider
              sx={{
                mt: "1rem",
                m: 1,
                mb: "1rem",
                border: 0,
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            />
            <Typography
              fontWeight={700}
              fontSize="1.53125rem"
              fontFamily={"Aeonik"}
            >
              {t(sectionTitle)}:
            </Typography>

            <Divider
              sx={{
                mt: "1rem",
                m: 1,
                mb: "1rem",
                border: 0,
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            />

            <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
              {dataArr.map((item, index) => {
                const parts = [];
                const regex = /\d+\.\d+|\d+|[^\d]+/g;
                let match;
                while ((match = regex.exec(item.label)) !== null) {
                  parts.push(match[0]);
                }

                return (
                  <Box
                    key={index}
                    sx={{
                      flexBasis: "0px",
                      WebkitFlex: 1,
                      flexGrow: 1,
                      maxWidth: "95%", // 8px × 2 = 16px gap between items
                      // width: "100%", // ensures full width
                      // minWidth: { xs: "98%",sm:'48%',md:'31%'},
                      p: "2px", // optional
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: item.color,
                        p: 2,
                        borderRadius: 1,
                        color: "#000",
                        // display: "flex",
                        // alignItems: "center",
                        // width: "100%",      // instead of 350
                        minWidth: { xs: "98%", sm: "48%", md: "31%" }, // optional
                        // flexWrap: "wrap",
                      }}
                    >
                      {parts.map((part, i) => (
                        <Typography
                          key={i}
                          variant="body1"
                          component="span"
                          sx={{
                            fontWeight: /^\d+(\.\d+)?$/.test(part)
                              ? "bold"
                              : 500,
                            mr: 0.5,
                          }}
                        >
                          {part}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )
      )}
     <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <InfoButton pageName="DASHBOARD" />
      </Box>


    </Box>
  </Box>
    // </Box>
  );
};

export default NewDashboard;
